var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3965 11.0767C20.7354 11.0767 18.4771 8.7085 18.4771 5.66895C18.4648 2.69043 20.7476 0.371094 23.3965 0.371094C26.0454 0.371094 28.3159 2.65381 28.3159 5.64453C28.3159 8.7085 26.0576 11.0767 23.3965 11.0767ZM9.28516 11.3574C6.96582 11.3574 5.00049 9.28223 5.00049 6.64551C4.98828 4.04541 6.97803 2.03125 9.28516 2.03125C11.5923 2.03125 13.5698 4.00879 13.5698 6.62109C13.5698 9.28223 11.6045 11.3574 9.28516 11.3574ZM2.55908 22.4292C0.911133 22.4292 0.300781 21.7456 0.300781 20.5493C0.300781 17.229 3.82861 13.2129 9.28516 13.2129C11.4824 13.2129 13.2402 13.8477 14.583 14.7266C11.8364 16.875 10.4082 20.5615 11.7021 22.4292H2.55908ZM15.7793 22.4292C13.7773 22.4292 13.0815 21.8188 13.0815 20.708C13.0815 17.5586 17.061 13.2373 23.3843 13.2373C29.7197 13.2373 33.6992 17.5586 33.6992 20.708C33.6992 21.8188 33.0034 22.4292 31.0015 22.4292H15.7793Z",
    fill: "#3C1460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.72c76bb3a5b122aea9c849d13001ce31.svg";
export { ForwardRef as ReactComponent };